import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Grid, Button, TextField, Typography } from '@mui/material';
// import { makeStyles } from '@mui/styles';
import CircularLoader from 'Components/Loaders/CircularLoader';
import useGlobalState from 'Hooks/useGlobalState';
// import { getDeviceByUuname } from 'Data/api';
import mainStyles from 'Styles/mainStyles';
import { useTranslation } from 'react-i18next';


const AddRoomDescription = (props) => {
	// const { deviceId } = useParams();
	const [state, dispatch] = useGlobalState();
	const navigate = useNavigate();
	const location = useLocation();
	const classes = mainStyles();
	const { t } = useTranslation();

	const [description, setDescripton] = useState(state.device.metadata.description ? state.device.metadata.description : '');

	useEffect(() => {
		console.log('AddRoomTitle - useEffect')
		// const fetchData = async () => {
		// 	let device = await getDeviceByUuname('skyen'+deviceId)
		// 	dispatch({ device: device });
		// }
		// fetchData();
		console.log(state.device, location)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const handleConfirm = () => {
		let device = state.device;
		device.metadata.description = description;
		dispatch({ device: device });
		navigate('../complete')
	}
	return (state.device ? 

		<Container component="main" maxWidth="sm">
			<Grid container justifyContent={'center'} alignItems='center'>
				<div className={classes.onboardContainer}>
					<Typography variant="h4" className={classes.title}>{t('Beskriv lokale')}</Typography>
				</div>
				<div className={classes.onboardImageContainer}>
					<img src="/assets/room.png" alt="Lokale" className={classes.onboardImageSkyen} />
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="h5" className={classes.title}>{t('Tilføj beskrivelse til lokale: ' + state.device.metadata.title)}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body2" className={classes.title}>{t('Beskriv hvad lokalet benyttes til, så det er lettere at finde i fremtiden. Det kan f.eks. være "4. klasse" eller "personalekøkken".')}</Typography>
				</div>
				<TextField
					autoFocus
					id="roomdescription"
					label={t('description')}
					variant="outlined"
					className={classes.textField}
					onChange={(event) => setDescripton(event.target.value)}
					value={description}
				/>

				<Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>{t('Bekræft beskrivelse')}</Button>
			</Grid>
		</Container>
		:
		<CircularLoader />
	)

}

export default AddRoomDescription;